import axios from 'axios';

const VivaPaymentsGeoLocation = axios.create({
    baseURL: process.env.BASE_URL
        ? process.env.BASE_URL
        : '/'
});

export default VivaPaymentsGeoLocation;
